<template>
  <div class="tag-search-wrapper">
    <div class="tag-search-header">
      <div class="title">#태그검색
        <div class="close-button" @click="close">
          <CloseButtonIcon/>
        </div>
      </div>
      <div class="tab">
        <button type="button" :class="currentTab === 'vod' ? 'tab-item selected' : 'tab-item'"
             @click.prevent="()=>selectTab('vod')">
          <span>시리즈</span>
        </button>
        <button type="button" :class="currentTab === 'movie' ? 'tab-item selected' : 'tab-item'"
             @click.prevent="()=>selectTab('movie')">
          <span>영화</span>
        </button>
      </div>
    </div>
    <div class="tag-list-wrapper">
      <div class="category-list" v-if="currentTab === 'vod'"  ref="tagList">
        <ul>
          <li v-for="(tagGroup, index) in broadCastTagList" :key="tagGroup.title + index">
            <div class="tag-group-item">
              <div class="tag-title">{{tagGroup.title}}</div>
            </div>
            <div class="tag-list" v-for="(subGroup, index) in tagGroup.tagsubgrouplist"
                 :key="tagGroup.title+'_tag'+index">
              <div :class="subGroup.title ? 'tag-sub-icon-title' : 'tag-sub-icon-title-none'">
                <img v-if="subGroup.iconimage" :src="getImage(subGroup.iconimage)" />
                <div class="sub-group-title">{{subGroup.title}}</div>
              </div>
              <span v-for="(tag, index) in subGroup.list"
                    :key="tag.text+index"
                    :class="tag.taggroup.indexOf('select') > -1 ? 'tag-item selected' : 'tag-item'"
                    @click.stop="()=>selectTag(tag)"
              >{{tag.text}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="category-list" v-if="currentTab === 'movie'"  ref="tagList">
        <ul>
          <li v-for="(tagGroup, index) in movieTagList" :key="tagGroup.title + index">
            <div class="tag-group-item">
              <div class="tag-title" v-if="tagGroup.title !== ''">{{tagGroup.title}}</div>
            </div>
            <div class="tag-list" v-for="(subGroup, index) in tagGroup.tagsubgrouplist"
                 :key="tagGroup.title+'_tag'+index">
              <div class="sub-group-title">{{subGroup.title}}</div>
              <span v-for="(tag, index) in subGroup.list"
                    :key="tag.text+index"
                    :class="tag.taggroup.indexOf('select') > -1 ? 'tag-item selected' : 'tag-item'"
                    @click.stop="()=>selectTag(tag)"
              >{{tag.text}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-menu" v-if="selectedTagList[currentTab].length > 0">
      <div class="reset" @click.prevent="resetSelectedTag">선택초기화</div>
      <div class="search" @click.prevent="searchSelectedTag">검색</div>
    </div>
  </div>

</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { SearchService } from '@/common/api/api.service'
import { TAGS_BROAD_CAST, TAGS_MOVIE } from '@/common/constant'
import { get, findIndex } from 'lodash'
import { EventBus } from '@/components/eventbus/EventBus'
import CloseButtonIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { SEARCH_BY_TAG } from '@/common/util/eventbus.const'
import { sendEventLogTagSearch } from '@/common/util/log.v2.send'
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'SearchTagCatalog',
  components: {
    CloseButtonIcon
  },
  props: {
    prevTagList: {
      type: Array
    },
    prevTabType: {
      type: String
    },
    tagListCloseFn: {
      type: Function
    }
  },
  data () {
    return {
      currentTab: 'vod', // vod, movie
      broadCastTagList: [],
      movieTagList: [],
      selectedTagList: {
        vod: [],
        movie: []
      }
    }
  },
  computed: {
    ...mapGetters(['tagSearchList'])
  },
  methods: {
    ...mapMutations([ 'setTagSearchList', 'deleteAllTag', 'setTagTabType', 'hideNavigationMenu', 'showNavigationMenu' ]),
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    selectTab (tabType) {
      this.currentTab = tabType
      window.scrollTo(0, 0)
      // this.$router.replace('/search/search_tag?type=' + tabType)
    },
    close () {
      this.tagListCloseFn()
    },
    _findAndSetTag (tagList) {
      tagList.forEach((tagGroup) => {
        tagGroup.tagsubgrouplist.forEach((subGroup) => {
          subGroup.list.forEach((tag) => {
            this.selectedTagList[this.prevTabType].forEach((selectedTag) => {
              if (selectedTag.text === tag.text && selectedTag.value === tag.value) {
                tag.taggroup = tag.taggroup + ' select'
              }
            })
          })
        })
      })
    },
    setData (force = false) {
      const boardCast = SearchService.getTagList({ type: TAGS_BROAD_CAST })
      const movie = SearchService.getTagList({ type: TAGS_MOVIE })
      this.axios.all([boardCast, movie]).then(this.axios.spread((boardCastRes, movieRes) => {
        const tempBroadCastTagList = get(boardCastRes, ['data', 'taggrouptitlelist'], [])
        const tempMovieTagList = get(movieRes, ['data', 'taggrouptitlelist'], [])
        if (!force) {
          if (this.prevTagList && this.prevTabType) { // 기존 조회정보가 있을때
            this.currentTab = this.prevTabType
            this.selectedTagList[this.prevTabType] = this.prevTagList.map((tag) => {
              return {
                taggroup: tag.taggroup + ' select',
                text: tag.text.replace('#', ''),
                value: tag.value
              }
            })
            this._findAndSetTag(tempBroadCastTagList)
            this._findAndSetTag(tempMovieTagList)
          }
        }
        this.broadCastTagList = tempBroadCastTagList
        this.movieTagList = tempMovieTagList
      }))
    },
    selectTag (tag) {
      if (tag.taggroup.indexOf('select') > -1) {
        this.selectedTagList[this.currentTab] =
          this.selectedTagList[this.currentTab].filter((selectedTag, index) => index !== findIndex(this.selectedTagList[this.currentTab], tag))
        tag.taggroup = tag.taggroup.replace(' select', '')
      } else {
        tag.taggroup = tag.taggroup + ' select'
        this.selectedTagList[this.currentTab].push(tag)
      }
    },
    resetSelectedTag () {
      this.selectedTagList[this.currentTab].map((selectedTag) => {
        selectedTag.taggroup = selectedTag.taggroup.replace(' select', '')
        return selectedTag
      })
      this.selectedTagList[this.currentTab] = []
      this.setData(true)
    },
    searchSelectedTag () {
      this.deleteAllTag()
      this.setTagTabType(this.currentTab)
      const tagList = this.selectedTagList[this.currentTab]
      const searchTags = tagList.map((tag) => {
        return {
          taggroup: tag.taggroup.replace(' select', ''),
          text: '#' + tag.text,
          value: tag.value
        }
      })
      sendEventLogTagSearch({ type: this.currentTab, tagDataList: tagList })
      window.scrollTo(0, 0)
      this.setTagSearchList(searchTags)
      EventBus.$emit(SEARCH_BY_TAG, { tab: this.currentTab })
    }
  },
  mounted () {
    enableBodyScroll()
  },
  created () {
    this.hideNavigationMenu()
    this.currentTab = get(this.$route, 'query.type', 'vod')
    this.setData()
  },
  beforeDestroy () {
    this.showNavigationMenu()
  },
  watch: {
    currentTab () {
      this.hideNavigationMenu()
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/search.css"></style>
